import { fg } from '@atlaskit/platform-feature-flags/fg';

const MULTI_SITE_SEARCH_PRODUCTS = ['confluence', 'jira'];

/** Whether FPS can search the current site and any explicitly selected additional sites. */
export const serveFpsMultiSiteSearchExperiment = ({
	primaryProduct,
}: {
	primaryProduct?: string | null;
} = {}): boolean =>
	Boolean(primaryProduct && MULTI_SITE_SEARCH_PRODUCTS.includes(primaryProduct)) &&
	fg('rovo_fps_enable_multi_site_search');
